module.exports = "/_next/static/images/kit-phone-diputi@2x-min-eb60bc377263534076614491580f604a.png.webp";